import React, { useState } from 'react';

const SongUploadForm = () => {
    const [file, setFile] = useState(null); // For storing selected file
    const [audioPreview, setAudioPreview] = useState(null); // For audio preview
    const [isUploading, setIsUploading] = useState(false); // For tracking upload state
    const [uploadProgress, setUploadProgress] = useState(0); // For upload progress

    // Handle file change (Audio File)
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile && selectedFile.type.startsWith('audio/')) {
            setFile(selectedFile);
            const audioUrl = URL.createObjectURL(selectedFile); // Create URL for audio preview
            setAudioPreview(audioUrl); // Set preview URL
        } else {
            alert('Please select an audio file.');
        }
    };

    // Handle form submission (upload)
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!file) {
            alert('Please select a song file.');
            return;
        }

        setIsUploading(true);
        setUploadProgress(0);

        // Simulating file upload (replace with actual upload logic)
        const simulateUpload = setInterval(() => {
            setUploadProgress((prev) => {
                if (prev >= 100) {
                    clearInterval(simulateUpload);
                    setIsUploading(false);
                    alert('Upload complete!');
                    return 100;
                }
                return prev + 10;
            });
        }, 500);
    };

    return (
        <div className="container p-4">
            <h2 className="text-2xl font-bold mb-4">Upload Song</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="songFile" className="block mb-2">Choose an audio file:</label>
                    <input
                        type="file"
                        id="songFile"
                        accept="audio/*"
                        onChange={handleFileChange}
                        className="border p-2 rounded"
                    />
                </div>

                {/* Audio Preview */}
                {audioPreview && (
                    <div className="mb-4">
                        <audio controls>
                            <source src={audioPreview} type="audio/mp3" />
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                )}

                {/* Upload Button and Progress */}
                <div>
                    <button
                        type="submit"
                        disabled={isUploading}
                        className={`p-2 rounded ${isUploading ? 'bg-gray-400' : 'bg-blue-500'}`}
                    >
                        {isUploading ? 'Uploading...' : 'Upload Song'}
                    </button>
                </div>

                {/* Upload Progress */}
                {isUploading && (
                    <div className="mt-4">
                        <progress value={uploadProgress} max="100" className="w-full" />
                        <p>{uploadProgress}%</p>
                    </div>
                )}
            </form>
        </div>
    );
};

export default SongUploadForm;
